// extracted by mini-css-extract-plugin
module.exports = {"section":"styles-module__section___22kYM","isLast":"styles-module__isLast___1nhQJ","sectionHeading":"styles-module__sectionHeading___DEiCE"};